// MRS Studios — Scroll fade-in animations
(function () {
  'use strict';

  function initFadeIn() {
    var elements = document.querySelectorAll('.mrs-fade');
    if (!elements.length) return;

    // threshold:0 fires as soon as 1px enters the viewport (even partially-visible
    // elements at the bottom of a short page).  rootMargin pre-loads 120px below fold.
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px 120px 0px' });

    elements.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFadeIn);
  } else {
    initFadeIn();
  }
})();
